import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "store";
import { login_transalation } from "transalations";
import Button from "ui-components/Button";
import { set_localize_content } from "utils/helper";
import {
  clearDataFromLocalStorage,
  getStringFromLocalStorage,
  saveStringToLocalStorage,
} from "utils/localStore";

export default function LoginModal(props: any) {
  const { classes } = props;
  const language = useSelector((state: RootState) => state.language.language);
  const navigate = useNavigate();
  const theme = useTheme() as any;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const token = getStringFromLocalStorage("token");

  useEffect(() => {
    if (isMobile || token) {
      navigate("/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className={"login_banner"}>
      <div className={classes.login_banner_inner}>
        <div className={classes.welcome_screen}>
          <h1
            className="Kanit-SemiBold text-white"
            style={{ textTransform: "uppercase" }}
          >
            {set_localize_content(login_transalation.welcome, language)}
          </h1>
          <div style={{marginBottom:12 , marginTop:10}}>
            <h2
              className="Kanit-Thin text-white"
              onClick={() => navigate("/phone-verify")}
              style={{ marginTop: 12, cursor: "pointer" }}
            >
              {set_localize_content(
                login_transalation.dont_have_account,
                language
              )}{" "}
              <span className="Kanit-Bold text-white">
                {set_localize_content(login_transalation.sign_up, language)}
              </span>
            </h2>
          </div>

          <div className={classes.welcome_buttons}>
            <Button
              classesNames={"button_two Kanit-SemiBold text-blue"}
              value={set_localize_content(login_transalation.login, language)}
              onClick={() => navigate("/login")}
            />
            <Button
              classesNames={"button_one Kanit-SemiBold text-white"}
              onClick={() => {
                saveStringToLocalStorage("membership", "membership");
                clearDataFromLocalStorage("token");
                clearDataFromLocalStorage("user");
                clearDataFromLocalStorage("session_expired");
                navigate("/service-method");
              }}
              value={set_localize_content(
                login_transalation.continue_without_membership,
                language
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
